const colLinks = [
  { label: "头版大瓜", href: "#headline" },
  { label: "吃瓜瓜棚", href: "#columns" },
  { label: "实时热榜", href: "#hot" },
  { label: "吃瓜指南", href: "#guide" },
  { label: "关于我们", href: "#about" },
];

export default function GuaFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          {/* brand */}
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <span className="font-heading text-xl font-black">瓜</span>
              </span>
              <span className="font-heading text-2xl font-black tracking-tight">每日大瓜</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              专注娱乐吃瓜情报与行业舆情观察。瓜友求锤得锤、预言家挖坟、粉丝脱粉回踩、
              站姐与业内匿名爆料，多路信源交叉验证。理性吃瓜，让子弹飞一会儿。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["#理性吃瓜", "#求锤得锤", "#不传谣", "#吃瓜情报站"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {/* nav */}
          <nav aria-label="页脚导航">
            <h4 className="text-sm font-bold tracking-wider text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {colLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* contact */}
          <div>
            <h4 className="text-sm font-bold tracking-wider text-foreground-900">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-600" aria-hidden="true" />
                <a href="mailto:editor@dagu-media.cn" className="hover:text-primary-700">
                  editor@dagu-media.cn
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-question-answer-line mt-0.5 text-accent-600" aria-hidden="true" />
                <a href="#guide" className="hover:text-primary-700">
                  吃瓜指南与 FAQ
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-user-voice-line mt-0.5 text-secondary-600" aria-hidden="true" />
                <a href="#about" className="hover:text-primary-700">
                  匿名投稿入口
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {year} 每日大瓜 Melon Daily · 本平台内容为娱乐舆情观察与公开信息整理，不做任何事实性结论，请读者理性判断。
          </p>
          <p className="text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-700">
              回到顶部 <i className="ri-arrow-up-line" aria-hidden="true" />
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}